import usePrivateAxios from '@/common/api/usePrivateAxios'
import { defaultTransformerResponse } from '@/common/constants/defaultTransformerResponse.constant'
import { Mapper } from '@/common/services/mapper'
import { MetaResponse } from '@/common/types/metaResponse'
import { keepPreviousData, useQuery } from '@tanstack/react-query'

type UseTmaisNfcesProps<T> = {
  filters?: {
    search?: string
    page?: number
    status?: string
    uploadedById?: string
    establishmentCompanyId?: string
    createdAtGteq?: string
    createdAtLteq?: string
  }
  mapper?: (data: any) => T
}

export const useTmaisNfces = <T,>({
  filters: { search = '', page, status, uploadedById, establishmentCompanyId, createdAtGteq, createdAtLteq } = {},
  mapper = Mapper.default<T>(),
}: UseTmaisNfcesProps<T>) => {
  const privateAxios = usePrivateAxios()

  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    isPending,
    ...rest
  } = useQuery({
    queryKey: ['tmaisNfces', search, page, status, uploadedById, establishmentCompanyId, createdAtGteq, createdAtLteq],
    queryFn: () => {
      return privateAxios.get('/tmais/nfces', {
        params: {
          search,
          page,
          'q[uploaded_by_id_eq]': uploadedById,
          'q[created_at_gteq]': createdAtGteq,
          'q[created_at_lteq]': createdAtLteq,
          'q[status_eq]': status,
          'q[establishment_company_id_eq]':
            establishmentCompanyId && establishmentCompanyId !== 'null' ? establishmentCompanyId : undefined,
          'q[establishment_company_id_null]': establishmentCompanyId === 'null' ? true : undefined,
        },
      })
    },
    select: (data: { data: { data: any[]; meta: MetaResponse } }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      }
    },
    placeholderData: keepPreviousData,
  })

  return { data, meta, isPending, ...rest }
}
